import { render, staticRenderFns } from "./FormCanvas.vue?vue&type=template&id=5817632e&scoped=true&"
import script from "./FormCanvas.vue?vue&type=script&lang=js&"
export * from "./FormCanvas.vue?vue&type=script&lang=js&"
import style0 from "./FormCanvas.vue?vue&type=style&index=0&id=5817632e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5817632e",
  null
  
)

export default component.exports